


















import Vue from 'vue';
import { CampaignRecipient, ClickRecipient } from '@/types';
import LinkActivity from './LinkActivity.vue';

interface LinkRecipient {
  recipients: CampaignRecipient[],
  url: string,
}

export default Vue.extend({
  props: {
    clicks: {
      type: Array as () => ClickRecipient[],
      default() {
        return [];
      },
    },
    webVersionUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    urls(): string[] {
      const links: string[] = [];
      this.clicks.forEach((click: ClickRecipient) => {
        // Check the url and replace with web based email url
        if (click.url === 'Link to web-based version of this email') {
          click.url = this.webVersionUrl;
        }
        if (!links.includes(click.url)) {
          links.push(click.url);
        }
      });
      return links;
    },
    linkRecipients() {
      const links: LinkRecipient[] = [];
      this.urls.forEach((url) => {
        const link: LinkRecipient = {
          recipients: [],
          url,
        };
        this.clicks.forEach((click) => {
          if (url === click.url) {
            link.recipients.push({
              emailAddress: click.emailAddress,
              name: click.name,
              customFields: click.customFields,
            });
          }
        });
        links.push(link);
      });
      return links;
    },
  },
  components: {
    'link-activity': LinkActivity,
  },
});
